<template>
  <div>
    <div v-if="!userloading && user.login" class="pa-2 basic">
      <v-row no-gutters align="center" justify="center" >
        <v-col cols="12">

          <v-card flat class="pa-4 ma-3" v-for="each_category in links" :key="each_category.category">
            <v-row dense>
              <v-col cols="12" class="title font-weight-bold mb-2">
                {{ each_category.category }}
              </v-col>
            </v-row>
            <v-row dense>

              <v-col
                cols="3"
                v-for="each_link in each_category.link"
                :key="each_link._id" >

                <v-card flat :href="'https://youtu.be/'+each_link.link" target="_blank" class="body-2">
                  <v-img :src="'https://img.youtube.com/vi/'+each_link.link+'/hqdefault.jpg'" />
                  <div class="mt-2 font-weight-bold subtitle-2">
                    {{ each_link.title }}
                  </div>
                </v-card>
              </v-col>

            </v-row>
          </v-card>

        </v-col>

      </v-row>
    </div>
    <div v-if="!userloading && !user.login" >
      <NeedLogin />
    </div>
    <div v-if="userloading">
      <UserLoading />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

import firebase from 'firebase/app';
import 'firebase/auth';
import axios from 'axios';

import api_conf from '../config/config.json';

import { mapGetters } from 'vuex';

import UserLoading from './User/UserLoading';

export default {
  components: {
    UserLoading,
  },
  props: {
    msg: String,
  },
  computed: {
    ...mapGetters({
      user: "user",
      mobile: "mobile",
      data: "data",
      userloading: "userloading",
      id_token: "id_token"
    }),
  },
  data: () => {
    return {
      categories: [],
      links: [],
    }
  },
  mounted: async function() {
    this.$nextTick(async function() {
      await this.reload_category();
    });
  },
  methods: {
    reload_category: async function() {

      this.categories=[];

      if ( firebase.auth().currentUser) {

        const id_token = await firebase.auth().currentUser.getIdToken();
        const categories_ = await axios.get(
          api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/youtube/category', {
          params: { email: this.user.data.email },
          headers: {'id_token': id_token},
        });

        for ( const each of categories_.data ) {
          this.categories.push({
            name: each.name,
            id: each.id,
            _id: each._id,
            children: 0,
          });
        }

        await this.reload_link();

      } else {
        setTimeout(async () => {
          await this.reload_category();
        }, 500);
      }
    },

    reload_link: async function() {

      this.links = [];

      if ( firebase.auth().currentUser) {

        const id_token = await firebase.auth().currentUser.getIdToken();
        const links_ = await axios.get(
          api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/youtube', {
          params: { email: this.user.data.email },
          headers: {'id_token': id_token},
        });

        for ( const each_category of this.categories ) {

          let t = {
            category: each_category.name,
            category_id: each_category._id,
            link: [],
          };

          for ( const each_link of links_.data ) {

            if ( each_link.category == each_category._id ) {
              t.link.push(each_link);

              each_category.children++;
            }
          }

          this.links.push(t);
        }

      } else {
        setTimeout(async () => {
          await this.reload_link();
        }, 500);
      }

    },

  }

}
</script>

<style scoped>

.theme--dark.v-divider {
    border-color: #FBDE44FF !important;
}

.op_btn {
  position:absolute;
  right:0;
  top:0;
}

.op_btn::before {
  color: transparent;
}

.op_btn::hover {
  color: transparent;
}

</style>
